




























































































































import {Component} from 'vue-property-decorator';
import Vue from 'vue';
import {Action, State} from 'vuex-class';
import {RegisterEnum} from '@/store/auth/auth.enum';
import {
  Member,
  MemberInitState
} from '@/store/member/member.types';
import UploadFileComponent from '@/components/upload/UploadFile.vue';
import {Toast} from '@/store/toast/toast.types';
import {ResponseCode} from '@/class/http';
import BgThemePublic from '@/components/bg-theme-public.vue';

@Component({
  components: {
    UploadFileComponent,
    BgThemePublic
  }
})
export default class SteppersSevenComponent extends Vue {

  @State('member') memberState!: MemberInitState;
  @Action('_Loading', {namespace: 'loading'}) Loading!: (payload: boolean) => Promise<void>;
  @Action('_registerMember', {namespace: 'member'}) registerMember!: (payload: Member) => Promise<void>;
  @Action('_getCheckFile', {namespace: 'file'}) getCheckFile!: (payload: string) => Promise<void>;
  @Action('_Toast', {namespace: 'toast'}) Toast!: (payload: Toast) => Promise<void>;

  public docReady = false;
  public modalTerm = false;
  public condition = false;
  public MemberData = {} as Member;

  async mounted() {
    if (JSON.parse(localStorage.getItem(RegisterEnum.Register) as string) as Member === null) {
      await this.$router.push('/register');
      return;
    }
    this.MemberData = JSON.parse(localStorage.getItem(RegisterEnum.Register) as string) as Member;
    this.docReady = true;
    this.Loading(false);
  }

  ChangeData() {
    localStorage.setItem(RegisterEnum.Register, JSON.stringify(this.MemberData).toString());
  }

  actionSetProfile(refId: string) {
    this.MemberData.profile = refId;
    this.ChangeData()
  }

  actionSetIdDoc(refId: string) {
    this.MemberData.identificationCardDoc = refId;
    this.ChangeData()
  }

  actionSetApplicationDoc(refId: string) {
    this.MemberData.applicationDoc = refId;
    this.ChangeData()
  }

  actionSetParentalConsentLetterDoc(refId: string) {
    this.MemberData.parentalConsentLetterDoc = refId;
    this.ChangeData()
  }

  actionSetIdLetterConsentPersonalInformationDoc(refId: string) {
    this.MemberData.letterConsentPersonalInformationDoc = refId;
    this.ChangeData()
  }

  async submitMember() {
    await this.Loading(true);
    await this.MemberData.memberServices.forEach((x) => delete x.serviceId);
    let member: any = this.MemberData;
    member.currentDistricts = Number(this.MemberData.currentDistricts);
    member.currentAmphures = Number(this.MemberData.currentAmphures);
    member.currentProvinces = Number(this.MemberData.currentProvinces);
    member.weakPassword = false;


    let resProfile = JSON.parse(JSON.stringify(await this.getCheckFile(this.MemberData.profile)));
    if (resProfile.length === 0) {
      this.Toast({
        message: 'กรุณาอัปโหลด รูปถ่าย',
        heading: 'กรุณาอัปโหลดไฟล์',
        type: 'warning',
      });
      await this.Loading(false);
      return;
    }

    await this.Loading(false);
    this.modalTerm = true;
  }

  async acceptCondition(e: boolean) {
    this.condition = e
  }

  async onBack() {
    this.modalTerm = false;
  }

  async createMember() {
    await this.Loading(true);
    this.MemberData.conditions = true;
    this.MemberData.adminConditionsOne = false;
    this.MemberData.adminConditionsTwo = false;
    let resMember = await this.registerMember(this.MemberData);

    let stats = JSON.parse(JSON.stringify(resMember)).data as ResponseCode;
    if (stats.appCode === 20001) {
      localStorage.removeItem(RegisterEnum.Register);
      await this.Toast({
        message: 'สมัครสมาชิกเรียบร้อยแล้ว',
        heading: 'บันทึกข้อมูลสำเร็จ',
        type: 'success',
      });

      await this.$router.push('/');
    } else {
      await this.Toast({
        message: 'กรุณาลองใหม่อีกครั้ง',
        heading: 'สมัครสมาชิกไม่สำเร็จ',
        type: 'warning',
      });
      await this.$router.push('/');
    }
    await this.Loading(false);
  }
}
